const mutations = {
  
    ADD_POLO (state, value) {

        state.allpolos.push(value)

    },
    ALL_ARQUIVOS (state, value) {

        state.allarquivos = value

    },
    ALL_VIDEOS (state, value) {

        state.allvideos = value

    },
    ALL_SLIDES (state, value) {

        state.allslides = value

    },
    ALL_AUDIOS (state, value) {

        state.allaudios = value

    },
    ALL_QUESTIONARIOS (state, value) {

        state.allquestionarios = value

    },
    ALL_EXTRAS (state, value) {

        state.allextras = value

    },
    GET_EXTRAS (state, value) {

        state.extrasMateria = value

    },
    ALL_ARQUIVOS_TIPO (state, value) {

        state.allArquivosTipo = value

    },
    ALL_ARQUIVOS_DISCIPLINA (state, value) {

        state.allArquivosDisciplina = value

    },
    ALL_ARQUIVOS_VIDEOS (state, value) {

        state.allArquivosVideos = value

    },
    ALL_ARQUIVOS_SLIDES (state, value) {

        state.allArquivosSlides = value

    },
    ALL_ARQUIVOS_AUDIOS (state, value) {

        state.allArquivosAudios = value

    },
    ALL_ARQUIVOS_EXTRAS (state, value) {

        state.allArquivosExtras = value

    },
    SETAR_LINK (state, value) {

        state.link_arquivo = value

    }
}

export default mutations